import { ReplenishmentListPage } from "@/features/replenishment/pages/ReplenishmentListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/replenishment/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["replenishment.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ReplenishmentListPage,
});
